import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import {
  NEW_LEAD_DELAY,
  NEW_LEAD_DELAY_ALERT,
  NEW_LEAD_TIMEOUT,
  NEW_LEAD_TIMEOUT_ALERT,
} from "./qualifyLead";

type QualifyNewLeadPayload = {
  contactId: string;
};

export const qualifyNewLeadForContact = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
    alertOnLongRequest,
  } = useAPQuery();

  return useMutation({
    mutationFn: (payload: QualifyNewLeadPayload): Promise<string> => {
      return alertOnLongRequest(
        fetchWithAuth<string>("qualifyNewLeadForContact", payload.contactId, {
          requestOptions: { method: "post" },
        }),
        NEW_LEAD_DELAY,
        NEW_LEAD_DELAY_ALERT,
        NEW_LEAD_TIMEOUT,
        NEW_LEAD_TIMEOUT_ALERT
      );
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onSettled: (_, __, payload: QualifyNewLeadPayload) => {
      defaultOnMutateSettled([["dossiers", payload.contactId]]);
    },
  });
};
